module.exports = __webpack_public_path__ + "img/ghosttownthumb.9391ef2e.jpg";